import { useSeo } from '@/lib/useSeo'
import { PageHeader, Prose } from '@/components/public/PageHeader'

export function ForAgents() {
  useSeo({
    title: 'For USVI Agents',
    description:
      'How VICE works for USVI Agents: invitation only access, AWA assisted intake, guided review, and submission to ACE.',
  })
  return (
    <>
      <PageHeader
        eyebrow="For USVI Agents"
        title="One clean workflow."
        lede="VICE is built for trained USVI Agents. Accounts are provisioned by invitation."
      />
      <Prose>
        <h2>What you do in a day</h2>
        <ol>
          <li>
            <strong>Sign in.</strong> Email + password (confirmed at account creation). Session
            persists across visits.
          </li>
          <li>
            <strong>Open the dashboard.</strong> See open cases, pending transmissions, and daily
            throughput at a glance.
          </li>
          <li>
            <strong>Create an intake.</strong> Upload an entry document from the trade process that
            has been prepared for the shipment. AWA begins processing it right away.
          </li>
          <li>
            <strong>Review extracted fields.</strong> AWA surfaces flagged items first: low
            confidence text extraction, HTS mismatches, value outliers, duplicate entries.
          </li>
          <li>
            <strong>Ask the assistant.</strong> A chat panel is embedded in every review surface —
            ask why a flag fired or what a code means without leaving the page.
          </li>
          <li>
            <strong>Transmit.</strong> Review the data, confirm it is properly structured, and send
            it to ACE. Each submission is recorded and archived.
          </li>
          <li>
            <strong>Archive.</strong> Case moves to reconciled status. Reports aggregate across
            cases automatically.
          </li>
        </ol>

        <h2>Edge paths</h2>
        <ul>
          <li>
            <strong>Document unreadable.</strong> Clear error with a manual-entry fallback so the
            entry still gets to ACE.
          </li>
          <li>
            <strong>Validation fails.</strong> Field-level issues block transmit until resolved or
            justified. Every justification is logged.
          </li>
          <li>
            <strong>Transmit fails.</strong> Automatic retry with backoff. Dashboard surfaces the
            case for manual intervention.
          </li>
        </ul>

        <h2>Accessibility</h2>
        <p>
          Every surface is keyboard navigable, screen reader friendly, and meets{' '}
          <a href="/accessibility">WCAG 2.1 AA / Section 508</a>. Status changes announce via live
          regions. Flags are never communicated by color alone.
        </p>

        <h2>Invitation-only access</h2>
        <p>
          VICE accounts are provisioned by the program team. If you&apos;re a designated USVI
          Agent, you&apos;ll receive an invitation email. <a href="/contact">Contact us</a> if you
          need access.
        </p>
      </Prose>
    </>
  )
}
